import React, { useState, useEffect } from "react";

import { Modal } from "antd";
import "./SpecialInstructionsModal.css";

const SpecialInstructionsModal = ({
  open, onClose, data,
}) => {
  const [response, setResponse] = useState("-");

  useEffect(() => {
    if (data.response) {
      setResponse(data.response);
    }
  }, [data]);

  return (
    <Modal
      centered
      open={open}
      onCancel={() => onClose(false)}
      footer={null}
      className="SpecialInstructionsModal"
    >
      <div className="SpecialInstructionsModal__Header">
        <h4>Special Instructions requested by customer</h4>
        <p>Provide customers with updates</p>
      </div>
      <div className="SpecialInstructionsModal__Content">
        <div className="SpecialInstructionsModal__Instruction">
          <label>Special Instruction</label>
          <div className="SpecialInstructionsModal__InstructionText">
            {data?.comments || "No special instructions provided"}
          </div>
        </div>
        <div className="SpecialInstructionsModal__Update">
          <label>Genista Response</label>
          <div className="ResponseDiv">{response}</div>
        </div>
      </div>
    </Modal>
  );
};

export default SpecialInstructionsModal;
